import React, { useMemo } from 'react'
import GModal from 'tennders-market/common/components/element/GModal'
import InputLabeledContainer from 'tennders-common/form/components/new-inputs/InputLabeledContainer'
import { GButton, TextArea } from 'tennders-common/form/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import useTransactionOnHold from '../hooks/useTransactionOnHold'

const QcTransactionHoldModal = (props) => {
  const {
    onClose,
    initialForm,
    id,
    refreshFunction,
    onCloseFunction
  } = props
  const {
    form,
    success,
    onChange,
    onSubmit,
    errors,
    submitting,
    fail
  } = useTransactionOnHold({ id, initialForm })

  const renderReturn = useMemo(() => {
    if (success) {
      return (
        <>
          <FontAwesomeIcon icon={faCheckCircle} size="4x" className="color-green" aria-hidden="true" />
          <h2 className="bold mt-24 mb-24">Transaction On Hold</h2>
          <p className="mb-0 color-mid-gray">The transaction is On Hold in Company Directory<br />We have notified the broker</p>
        </>
      )
    }
    if (fail) {
      return (
        <>
          <FontAwesomeIcon icon={faCircleXmark} className="color-s" size="4x" aria-hidden="true" />
          <h2 className="bold mt-24 mb-24">Something Went Wrong</h2>
        </>
      )
    }
    return (
      <>
        <InputLabeledContainer
          form={form}
          onChange={onChange}
          errors={errors}
          name="reason"
          className="w-100"
          label="Hold Reason"
          renderInput={(props) => <TextArea className="w-100 form-input" {...props} />}
        />
        <div className="d-flex align-center justify-end mt-10">
          <GButton submitting={submitting} onClick={onSubmit} className="btn-border standard-btn text-12">
            Hold
          </GButton>
        </div>
      </>
    )
  }, [success, fail, form, errors])

  const close = () => {
    onClose()
    if (success) {
      if (refreshFunction) {
        refreshFunction(initialForm)
      }
      if (onCloseFunction) {
        onCloseFunction()
      }
    }
  }

  return (
    <GModal
      size="unset"
      isOpen
      close={close}
    >
      <div className="tennders-modal-body w-100 text-center">
        {renderReturn}
      </div>
    </GModal>
  )
}

export default QcTransactionHoldModal
